export default __webpack_public_path__ + "static/allan-west-11affcedd9423f45cae123ed3d3fb182.jpg";